// extracted by mini-css-extract-plugin
module.exports = {"name":"_92958ce","isSuspended":"_e555a23","status":"_4718bb6","multipleNameWrapper":"_056e4eb","oddsBoostIcon":"_21a40ba","right":"_67c98e6","inPlayIcon":"_4e60fc9"};